<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MjWMf0/tc-custom/9780718041496.jpg?1741152305564" alt="This image is the cover for the book We Are Charleston"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">We Are Charleston
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>We Are Charleston </i>not only recounts the events of that terrible day but also offers a history lesson that reveals a deeper look at the suffering, triumph, and even the ongoing rage of the people who formed Mother Emanuel A.M.E. church and the wider denominational movement.</b></p><p>On June 17, 2015, at 9:05 p.m., a young man with a handgun opened fire on a prayer meeting at the Mother Emanuel African Methodist Episcopal (AME) Church in Charleston, South Carolina, killing nine members of the congregation. The captured shooter, twenty-one-year-old Dylan Roof, a white supremacist, was charged with their murders. Two days after the shooting, while Roof’s court hearing was held on video conference, some of the families of his nine victims, one by one, appeared on the screen—forgiving the killer. The “Emanuel Nine” set a profound example for their families, their city, their nation, and indeed the world.</p><p>In many ways, this church’s story is America’s story—the oldest A.M.E. church in the Deep South fighting for freedom and civil rights but also fighting for grace and understanding. Fighting to transcend bigotry, fraud, hatred, racism, poverty, and misery. The shootings in June 2015, opened up a deep wound of racism that still permeates Southern institutions and remains part of American society.  </p><p><i>We Are Charleston</i> tells the story of a people, continually beaten down, who seem to continually triumph over the worst of adversity. Exploring the storied history of the A.M.E. Church may be a way of explaining the price and power of forgiveness, a way of revealing God’s mercy in the midst of tremendous pain. <i>We Are Charleston</i> may help us discover what can be right in a world that so often has gone wrong.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Herb Frazier, Bernard Edward Powers, Marjory Wentworth
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f903f1b